import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';
import Translator from '%app/js/common/services/translator';

const withTranslationsErrorMapper = (WrappedComponent) => {
    function inner({ errors }) {
        return (
            <React.Fragment>
                {Object.keys(errors).map(language => (
                    <div key={language}>
                        <FormHelperText>{Translator.trans((`simple_event.for_${language}_translation`))}</FormHelperText>
                        <WrappedComponent error errors={errors[language]} />
                    </div>
                ))}
            </React.Fragment>
        );
    }

    inner.propTypes = {
        errors: PropTypes.object.isRequired,
    };

    return inner;
};

export default withTranslationsErrorMapper;
